import axiosInstance from "../axiosInstance";

export const clearingsApi = {
  post: (path, params, headers, cancelToken) =>
    axiosInstance
      .post(`/clearings${path}`, params, {
        cancelToken: cancelToken?.token,
        headers,
      })
      .then((res) => {
        console.log(res);
        if (res?.data?.error) throw res.data;
        return res?.data;
        // if (res?.data?.error || res?.data?.status === 'error') throw res.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
  get: (path, params, headers, cancelToken) =>
    axiosInstance
      .get(
        `/clearings${path}`,
        { params },
        {
          cancelToken: cancelToken?.token,
          headers,
        }
      )
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
};

export const getClearings = async (params) =>
  clearingsApi.get("/GetClearings", params);

export const getInstitutes = async (params) =>
  clearingsApi.post("/GetInstitutesByTypeSelection", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const getInspection = async (params) =>
  clearingsApi.get("/GetInspection", params);

export const completeReviewPeriod = async (params) =>
  clearingsApi.get("/CompleteReviewPeriod", params);

export const runDraw = async (params) => clearingsApi.get("/runDraw", params);

export const getPaymentDecisionAppTypes = async (params) =>
  clearingsApi.get("/GetPaymentDecisionAppTypes", params);

export const getPaymentDecisionSummaryFromAppTypes = async (params) =>
  clearingsApi.post(
    "/GetPaymentDecisionSummaryFromAppTypes",
    JSON.stringify(params),
    { "Content-Type": "application/json" }
  );

export const createNewPayment = async (params) =>
  clearingsApi.post("/CreateNewPayment", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const getPayment = async (params) =>
  clearingsApi.get("/GetPayment", params);

export const exportClearingFile = async (params) =>
  axiosInstance
    .post(`/clearings/Export`, JSON.stringify(params), {
      headers: { "Content-Type": "application/json" },
      responseType: "blob", // 👈 critical for correct encoding
    })
    .then((res) => {
      if (res?.data?.error) throw res.data;
      return res;
      // if (res?.data?.error || res?.data?.status === 'error') throw res.data;
    })
    .catch((err) => {
      throw err.error ? err : err?.response?.data;
    });

export const savePayment = async (params) =>
  clearingsApi.post("/SavePayment", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const archiveApplications = async (params) =>
  clearingsApi.get("/ArchiveApplications", params);

export const exportFiles = async (params) =>
  clearingsApi.get("/Export", params);
